<template>
  <details class="group rounded-2xl bg-white">
    <summary
      class="flex cursor-pointer list-none items-center justify-between gap-2 px-4 py-3.5 outline-none md:py-6"
    >
      <h2 class="text-base group-open:font-bold">
        <slot name="title" />
      </h2>
      <!-- prettier-ignore -->
      <svg class="group-open:rotate-180 transition shrink-0" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.712 13.201a.846.846 0 0 1-1.248 0l-4.706-5a.98.98 0 0 1 0-1.326.846.846 0 0 1 1.248 0l4.082 4.337 4.082-4.337a.846.846 0 0 1 1.248 0 .98.98 0 0 1 0 1.326l-4.706 5Z" fill="#1A1B1D"/></svg>
    </summary>
    <div class="space-y-4 px-4 pb-3.5 md:pb-6">
      <slot name="default" />
    </div>
  </details>
</template>
